import type { ReactNode } from "react"

// One panel section: a heading with an optional note on the right, a divider
// above. The panel itself is the surface, so sections draw no box. `header`
// replaces the heading row, for a section headed by its own controls.
export default function Section({ title, aside, header, children }: { title?: string; aside?: string; header?: ReactNode; children: ReactNode }) {
  return (
    <section className="flex flex-col gap-2 border-t border-border px-5 py-4">
      {header ?? (
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="text-sm font-semibold text-foreground">{title}</h3>
          {aside && <span className="text-xs text-foreground">{aside}</span>}
        </div>
      )}
      {children}
    </section>
  )
}
